module.exports = __webpack_public_path__ + "media/images/alizza-8629d80451dfa6732d2f7213665aaac8.jpg";